import { lpFlowWithoutConsent } from '@wkda/conversational-carlead';

/**
 * `licensePlateUserPrompt` (asked after the user rejects the detected license plate) is a
 * free-text step, but @wkda/conversational-carlead ships it as `box-select` without answers,
 * which renders an empty options box under the message. Render it as plain text instead.
 */
export function fixLicensePlateUserPromptStep(flow) {
  return flow.map(step => step.field === 'licensePlate' && !step.answers?.length ? {
    ...step,
    type: 'text'
  } : step);
}
export const conversationalLpFlowWithoutConsent = fixLicensePlateUserPromptStep(lpFlowWithoutConsent);